import React, { useEffect, useState, createContext } from 'react';

const defaultState = {
    skus: {},
    updateSkus: () => { },
}

export const RootContext = createContext(defaultState)

export const RootProvider = ({ children }) => {
    let [skus, setSkus] = useState({})

    useEffect(() => {
        setSkus(getSkus())
    }, [])

    useEffect(() => {}, [skus])

    const updateSkus = (newSkus) => {
        setSkus(newSkus)
    }

    return (
        <RootContext.Provider
            value={{
                skus,
                updateSkus: updateSkus,
            }}
        >
            {children}
        </RootContext.Provider>
    )
}

const getSkus = () => {
    let cart = typeof window !== undefined && window.localStorage.getItem('cart');
    if(!cart) return {};
    cart = JSON.parse(cart);
    let skus = {}
    Object.keys(cart).map(key => skus[key] = { quantity: cart[key].qty, total: cart[key].price.totalCost })
    console.log('skus', skus)
    return skus;
}